import moment from 'moment-timezone';
import Request from 'files/Request.js';

class TrustedContactClass {

    active = true;
    date = null;
    email_address = null;
    first_name = null;
    full_name = null;
    id = null;
    last_name = null;
    phone_number = null;
    preferences = null;
    requiem_confirmation_date = null;
    requiem_generated = null;
    
    constructor() {
        return this;
    }

    create = (props = {}) => {
        this.active = props.active;
        this.date = props.date && moment.utc(props.date).local();
        this.email_address = props.email_address;
        this.first_name = props.first_name;
        this.full_name = props.full_name;
        this.id = props.id;
        this.last_name = props.last_name;
        this.phone_number = props.phone_number;
        this.preferences = props.preferences;
        this.requiem_confirmation_date = props.requiem_confirmation_date && moment.utc(props.requiem_confirmation_date).local();
        this.requiem_generated = props.requiem_generated;
        return this;
    }
}

export const fetchContact = async (utils, id) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { trusted_contact } = await Request.get(utils, '/users/', {
                id: id,
                type: 'trusted_contact_details'
            });
            resolve(new TrustedContactClass().create(trusted_contact));
        } catch(e){
            reject(e);
        }
    });
}

export default {
    create: props => new TrustedContactClass().create(props),
    get: fetchContact,
    new: () => new TrustedContactClass()
}
